export type CallSentenceCitationLlmOutput = {
  type: 'TRANSCRIPT'
  citedTranscriptSentences: {
    content: string
    id: string
    startTimeSeconds: number
    endTimeSeconds: number
  }[]
  content: string
}

export type CallResourceCitationLlmOutput = {
  type: 'FILE'
  content: string
  citedFiles: {
    resourceId: number
    pageNumber: number
  }[]
}

export type CallCitationLlmOutput = CallSentenceCitationLlmOutput | CallResourceCitationLlmOutput

export type DiscussionCitationLlmOutput = {
  actionItems: {
    action: string
    citations: CallCitationLlmOutput[]
  }[]
  contents: CallCitationLlmOutput[]
}

export type MatterArisingCitationLlmOutput = {
  description: CallCitationLlmOutput[]
  commentary: CallCitationLlmOutput[]
}

export type CallSentenceCitationApiResponse = {
  id: number
  content: string
}

export type CallSentencesCitationGroupApiResponse = {
  type: 'CALL_SENTENCE_GROUP'
  citations: CallSentenceCitationApiResponse[]
  minuteNodeContent: string
  minuteNodeId: number
  startSentenceId: string
  startSentenceIndex: number
  endSentenceId: string
  endSentenceIndex: number
}

export type CallResourceCitationApiResponse = {
  id: number
  resourceId: number
  resourcePageNumber: number
  content: string
}

export type CallResourceCitationGroupApiResponse = {
  type: 'CALL_RESOURCE_GROUP'
  citations: CallResourceCitationApiResponse[]
  minuteNodeContent: string
  minuteNodeId: number
}

export type CitationsApiResponse = (CallSentencesCitationGroupApiResponse | CallResourceCitationGroupApiResponse)[]

export function isCallSentenceCitationLlmOutput(citation: CallCitationLlmOutput): citation is CallSentenceCitationLlmOutput {
  return citation.type === 'TRANSCRIPT'
}

export function isCallResourceCitationLlmOutput(citation: CallCitationLlmOutput): citation is CallResourceCitationLlmOutput {
  return citation.type === 'FILE'
}

export function isCallSentenceGroupApiResponse(
  response: CallSentencesCitationGroupApiResponse | CallResourceCitationGroupApiResponse
): response is CallSentencesCitationGroupApiResponse {
  return response.type === 'CALL_SENTENCE_GROUP'
}

export function isCallResourceGroupApiResponse(
  response: CallSentencesCitationGroupApiResponse | CallResourceCitationGroupApiResponse
): response is CallResourceCitationGroupApiResponse {
  return response.type === 'CALL_RESOURCE_GROUP'
}
